.container{padding:1.5rem 1.625rem;padding-bottom:0}
/*# sourceMappingURL=add-edit-swap.component-V73JFFWV.css.map */
